import {AfterViewInit, Component, computed, inject, OnChanges, SimpleChanges, Type, ViewChild} from '@angular/core';
import {CommonModule, CurrencyPipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DataGridView, DataGridViewCollumn, Types} from '../../../Componente/DataGridView';
import {PopUpView} from '../../../Componente/PopUpView';
import {FloatingButtonComponent} from '../../../Componente/floatingButton';
import {DateSelect} from '../../../Akte/Controlls/DateSelect';
import {StatusPipe} from '../../../Pipes/StatusPipe';
import {VersandStepper} from '../../../Componente/versand-stepper/versand-stepper';

import {ToastService} from '../../../Akte/Services/Toasts/ToastService';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {PGFilterService} from '../../Services/PGFilterService';
import {Lauf} from '../../../Api/DcoApi/Abrechnung/Lauf';
import {NotificationService} from '../../../Services/NotificationService';
import {ArtikelEdit} from '../../../Admin/Controlls/EditViews/ArtikelEdit';
import {AktePopup} from '../Status/AktePopup';
import {GeneratingPopup} from './Popups/generating-popup/generating-popup';
import {MissingInbetriebnahmeListe} from './Popups/missing-inbetriebnahme-liste/missing-inbetriebnahme-liste';
import {FileUploadExport} from './Popups/file-upload-export/file-upload-export';

@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent, StatusPipe, VersandStepper, CurrencyPipe, ArtikelEdit
  ],
  selector: 'Abrechnung',
  templateUrl: './Abrechnung.html',
  standalone: true,
  styleUrl: './Abrechnung.css'
})
export class Abrechnung implements OnChanges, AfterViewInit {
  @ViewChild('Grid') childComponent!: DataGridView<Lauf>;
  toastService: ToastService;
  Types = Types;
  private modalService = inject(NgbModal);

  selectedIDs: number[] = [];

  dataurl = computed(() => { return `/AbrechnungData/List` })
  protected currencyPipe: Type<any> = CurrencyPipe;

  constructor(public pgService: PGFilterService) {
    this.toastService = inject(ToastService)
  }
  ngAfterViewInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  CreateNewInvoice()
  {
    var modal = this.modalService.open(GeneratingPopup, {
      backdrop: 'static', // Prevents closing when clicking outside the modal
      keyboard: false,     // Prevents closing when pressing the Escape key
      windowClass: 'modal-dialog-500px'
    });
    modal.componentInstance.CreateNewInvoice();
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
  }

  public upload(row: Lauf) {
    if (row.missingInbts.length > 0)
      return;

    var modal = this.modalService.open(FileUploadExport, {
      backdrop: 'static', // Prevents closing when clicking outside the modal
      keyboard: false,     // Prevents closing when pressing the Escape key
      windowClass: 'modal-dialog-500px'
    });
    modal.componentInstance.Partner = row.koopId;
    modal.componentInstance.Lauf = row.key;
    modal.componentInstance.StartUpload()
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });

  }

  public download(row: Lauf) {
    if (row.missingInbts.length > 0)
      return;

    var modal = this.modalService.open(FileUploadExport, {
      backdrop: 'static', // Prevents closing when clicking outside the modal
      keyboard: false,     // Prevents closing when pressing the Escape key
      windowClass: 'modal-dialog-500px'
    });
    modal.componentInstance.Partner = row.koopId;
    modal.componentInstance.Lauf = row.key;
    modal.componentInstance.StartDownload()
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
  }

  OpenAkten(Akten: number[])
  {
    var modal = this.modalService.open(MissingInbetriebnahmeListe);
    modal.componentInstance.Akten = Akten;
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
  }


}
